<div class="waiting-container">
    <!-- <img src="/assets/images/Skip Full Logo - Transparent.png" alt="Skip Logo" class="logo"> -->

    <h1 class="waiting-title">Downloading and synchronizing data</h1>
    <p class="waiting-subtitle">
        We are currently uploading and synchronizing your data. You can close this tab and when the process is complete we will send you an email about the completion of the upload.
    </p>

    <!-- Loading Animation Component -->
    <app-loading-page [message]="message$" [isFullScreen]="false"></app-loading-page>

    <div class="progress-container">
        <div class="progress-bar">
            <div class="progress-bar-fill" [style.width.%]="progress"></div>
        </div>
        <p class="progress-meta">
            <span class="progress-text">Uploaded Connectors</span> • <span class="progress-time">{{calculateTimeLeftInMins()}} min left</span>
        </p>
    </div>
</div>
